export default "__VITE_ASSET__DJL7Wkkn__"